import { LOAD_GOSPEL_BOOK } from '@/store/protocols'

export default [
    {
        name: 'gospel/view',
        path: '/gospel/view/:id/index.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_GOSPEL_BOOK.join('/')
        }
    }
]
